import { Modal } from 'medere-ui-framework'
import { Column } from 'primereact/column'
import { DataTable } from 'primereact/datatable'
import { ContractHonorariumCreateResultDTO, ContractHonorariumCombinationDTO } from '../../../dto/contractHonorarium/ContractHonorariumDTO'
import { nameOrGeneral } from '../contractHonorariumFormat'

interface DuplicateCombinationsModalProps {
  result: ContractHonorariumCreateResultDTO | null
  onClose: () => void
}

function describeResult(result: ContractHonorariumCreateResultDTO): string {
  const repeated = result.duplicates.length
  const which = repeated === 1
    ? '1 combinación ya tiene'
    : `${repeated} de ${result.total} combinaciones ya tienen`
  return `No se creó ninguna distribución porque ${which} una distribución vigente o una que empieza ese mismo día.`
}

export default function DuplicateCombinationsModal({ result, onClose }: Readonly<DuplicateCombinationsModalProps>) {
  const nameColumn = (field: keyof ContractHonorariumCombinationDTO) =>
    (row: ContractHonorariumCombinationDTO) => nameOrGeneral(row[field])

  return (
    <Modal
      visible={result != null}
      setVisible={(nextVisible) => {
        if (!nextVisible) onClose()
      }}
      header={<span className='chd-modal-title'>Combinaciones repetidas</span>}
      width='w-xlarge'
      className='chd-modal'
      footerButtonLeftText='Cerrar'
      onClickLeftBtn={onClose}
    >
      {result && (
        <div className='chd-modal-body'>
          <p className='chd-confirm-text'>{describeResult(result)}</p>
          <DataTable
            value={result.duplicates}
            size='small'
            scrollable
            scrollHeight='20rem'
            className='chd-modal-table'
          >
            <Column header='Emisor' body={nameColumn('billingEntityName')} />
            <Column header='Obra social' body={nameColumn('healthEntityName')} />
            <Column header='Plan' body={nameColumn('healthEntityPlanName')} />
            <Column header='Profesional' body={nameColumn('professionalName')} />
            <Column header='Nomenclador' body={nameColumn('nomenclatorName')} />
            <Column header='Edificio' body={nameColumn('buildingName')} />
          </DataTable>
        </div>
      )}
    </Modal>
  )
}
